<template>
  <div>
    <b-modal
      v-model="showPopUpPj"
      has-modal-card
      destroy-on-hide
      class="modal">
      <ajout-piece-jointe :autoSave="autoSave" :checkPerm="checkPermissions(perm)"/>
    </b-modal>
    <button
      class="button"
      :class="{'button-access-no-permission': !checkPermissions(perm)}"
      :disabled="disabled"
      @click="checkPermissions(perm) ? showPopUpPj = true : showPopUp()">
      <b-icon icon="paperclip" type="is-default"></b-icon>
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AjoutPieceJointe from '@/components/general/ajoutPieceJointe';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    perm: {
      type: Object,
      required: true,
    },
    autoSave: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    AjoutPieceJointe,
  },
  data() {
    return {
      showPopUpPj: false,
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
};
</script>

<style>

</style>
